import { render, staticRenderFns } from "./ClubSingle.vue?vue&type=template&id=530209fc&"
import script from "./ClubSingle.vue?vue&type=script&lang=js&"
export * from "./ClubSingle.vue?vue&type=script&lang=js&"
import style0 from "./ClubSingle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClubSingle.vue"
export default component.exports